// extracted by mini-css-extract-plugin
module.exports = {"box":"WhyUs--box--1fCEQ","max_width":"WhyUs--max_width--1qpcB","white":"WhyUs--white--3xhg2"};